import { Flex, Menu, Typography } from 'antd';
import Link from 'next/link';
import { useRouter } from 'next/router';
import styles from '../sidebar.module.css';
const { Text } = Typography;

export default function AccountSidebar() {
   const router = useRouter();

   const nav = [
      {
         text: 'Profile Settings',
         href: '/account/settings',
      },
      {
         text: 'Subscriptions',
         href: '/account/subscription',
      },
   ];
   return (
      <>
         <div className={styles.sidebar}>
            <Flex vertical gap={16} style={{ padding: '12px' }}>
               <Text>Account settings</Text>
            </Flex>
            <Menu
               mode="inline"
               selectedKeys={[router.pathname]}
               items={nav.map((item, i) => ({
                  key: item.href,
                  label: <Link href={item.href}>{item.text}</Link>,
                  icon: item.icon,
               }))}
               style={{ border: 'none', background: 'transparent', padding: 0 }}
            />
         </div>
      </>
   );
}
